export const COURSE_LIST_TABLE = 'courseListTable';
export const COMPANY_TABLE = 'companyTable';
export const COMPANY_STUDENT_TABLE = 'companyStudentTable';
export const CERTIFICATE_TABLE = 'certificateTable';
export const DATION_INSTANCE_USERS_TABLE = 'dationInstanceUsersTable';
export const DASHBOARD_DRIVING_LICENSE_TABLE = 'dashboardDrivingLicenseTable';
export const LOGBOOK_TABLE = 'logbookTable';
export const ESTABLISHMENT_TABLE = 'establishmentTable';
